export const BASE_URL =
  window.location.origin === "https://dev.linkstep.com"
    ? "/devapi"
    : window.location.origin === "https://app.linkstep.com"
      ? "/api"
      : "http://localhost:5001";
export const API_BASE = `${BASE_URL}/api`;

// Auth
const AUTH_BASE = "/auth";
export const ME_USER_URL = `${API_BASE}${AUTH_BASE}/me`;
export const REGISTER_COMPANY_URL = `${API_BASE}${AUTH_BASE}/register-company`;
export const REGISTER_USER_URL = `${API_BASE}${AUTH_BASE}/register`;
export const LOGIN_USER_URL = `${API_BASE}${AUTH_BASE}/login`;
export const LOGOUT_USER_URL = `${API_BASE}${AUTH_BASE}/logout`;
export const REFRESH_USER_URL = `${API_BASE}${AUTH_BASE}/refresh-token`;
export const UPDATE_USER_URL = `${API_BASE}${AUTH_BASE}/update-user`;
export const GET_USERS = `${API_BASE}${AUTH_BASE}/get-users`;
export const GET_COMPANY_USERS = `${API_BASE}${AUTH_BASE}/get-company-users`;
export const ADD_COMPANY_USER = `${API_BASE}${AUTH_BASE}/add-company-user`;
export const ACTIVATE_COMPANY_USER = `${API_BASE}${AUTH_BASE}/activate-company-user`;
export const DEACTIVATE_COMPANY_USER = `${API_BASE}${AUTH_BASE}/deactivate-company-user`;
export const RESEND_INVITATION = `${API_BASE}${AUTH_BASE}/resend-invitation`;
export const RESET_PASSWORD = `${API_BASE}${AUTH_BASE}/reset-password`;
export const CHECK_UNIQUE_EMAIL = `${API_BASE}${AUTH_BASE}/check-unique-email`;
export const SIGN_UP_COMPANY_USER = `${API_BASE}${AUTH_BASE}/sign-up-company-user`;
export const IMPERSONATE_COMPANY = `${API_BASE}${AUTH_BASE}/impersonate-company`;
export const IMPERSONATE_USER = `${API_BASE}${AUTH_BASE}/impersonate-user`;
export const CANCEL_IMPERSONATE_USER = `${API_BASE}${AUTH_BASE}/cancel-impersonate-user`;

// User
const USER_BASE = "/user";
export const ADD_USER_PHOTO = `${API_BASE}${USER_BASE}/add-user-photo`;
export const GET_USER_REPORTS = `${API_BASE}${USER_BASE}/get-user-reports`;

// Forms
const FORM_BASE = "/form";
export const CREATE_NEW_FORM = `${API_BASE}${FORM_BASE}/create-new-form`;
export const GET_MY_FORMS = `${API_BASE}${FORM_BASE}/get-forms`;
export const GET_MY_FORMS_SUMMARY_SHORT = `${API_BASE}${FORM_BASE}/get-forms-summary-short`;
export const GET_SUBMITTABLE_FORMS = `${API_BASE}${FORM_BASE}/get-submittable-forms`;
export const GET_MY_FORM = `${API_BASE}${FORM_BASE}/get-form`;
export const GET_STATUSES = `${API_BASE}${FORM_BASE}/get-form-statuses`;
export const PUBLISH_MY_FORM = `${API_BASE}${FORM_BASE}/publish-form`;
export const UNPUBLISH_MY_FORM = `${API_BASE}${FORM_BASE}/unpublish-form`;
export const UPDATE_FORM_NEW = `${API_BASE}${FORM_BASE}/update-form-new`;
export const LOCK_MY_FORM = `${API_BASE}${FORM_BASE}/lock-form`;
export const UNLOCK_MY_FORM = `${API_BASE}${FORM_BASE}/unlock-form`;
export const CREATE_NEW_QUESTION = `${API_BASE}${FORM_BASE}/create-new-question`;
export const UPDATE_QUESTION = `${API_BASE}${FORM_BASE}/update-question`;
export const UPDATE_ANSWER_OPTION_QUESTION = `${API_BASE}${FORM_BASE}/update-answer-option-question`;
export const DELETE_QUESTIONS = `${API_BASE}${FORM_BASE}/delete-questions`;
export const SUBMIT_FORM = `${API_BASE}${FORM_BASE}/submit-form`;
export const GET_REPORTS = `${API_BASE}${FORM_BASE}/reports`;
export const SUBMITTED_FORM = `${API_BASE}${FORM_BASE}/submitted-form`;
export const DOWNLOAD_PDF_REPORT = `${API_BASE}${FORM_BASE}/download-pdf-report`;
export const UPDATE_USER_NOTIFICATIONS = `${API_BASE}${FORM_BASE}/update-form-user-notifications`;
export const ADD_SUBMISSION_FILES = `${API_BASE}${FORM_BASE}/add-submission-attachment`;
export const GET_SUBMISSION_FILES = `${API_BASE}${FORM_BASE}/get-submission-attachments`;
export const ADD_SUBMISSION_NOTE = `${API_BASE}${FORM_BASE}/add-submission-note`;
export const GET_SUBMISSION_NOTES = `${API_BASE}${FORM_BASE}/get-submission-notes`;
export const UPDATE_SUBMISSION_STATUS = `${API_BASE}${FORM_BASE}/update-submission-status`;
export const DELETE_SUBMISSION = `${API_BASE}${FORM_BASE}/delete-submission`;
export const GET_FORM_VERSIONS = `${API_BASE}${FORM_BASE}/get-form-versions`;
export const ADD_NOTE_FILES = `${API_BASE}${FORM_BASE}/add-note-files`;
export const DELETE_FORM = `${API_BASE}${FORM_BASE}/delete-form`;

// Locations
const LOCATION_BASE = "/location";
export const ADD_LOCATION = `${API_BASE}${LOCATION_BASE}/add-location`;
export const GET_LOCATIONS = `${API_BASE}${LOCATION_BASE}/get-locations`;
export const UPDATE_LOCATIONS = `${API_BASE}${LOCATION_BASE}/update-location`;
export const DELETE_LOCATIONS = `${API_BASE}${LOCATION_BASE}/deactivate-location`;
export const GET_USER_LOCATIONS = `${API_BASE}${LOCATION_BASE}/get-user-locations`;
export const GET_LOCATION_USERS = `${API_BASE}${LOCATION_BASE}/get-location-users`;
export const GET_LOCATION_REPORTS = `${API_BASE}${LOCATION_BASE}/get-location-reports`;
export const GET_COMPANY_LOCATIONS = `${API_BASE}${LOCATION_BASE}/get-company-locations`;
export const GET_LOCATION_BASED_FORMS = `${API_BASE}${LOCATION_BASE}/get-location-based-forms`;
export const ADD_LOCATION_PHOTO = `${API_BASE}${LOCATION_BASE}/add-location-photo`;
export const GET_LOCATION_VENDORS = `${API_BASE}${LOCATION_BASE}/get-location-vendors`;

// Permissions
const PERMISSIONS_BASE = "/permissions";
export const GET_USER_PERMISSIONS = `${API_BASE}${PERMISSIONS_BASE}/get-user-permissions`;
export const UPDATE_USER_PERMISSIONS = `${API_BASE}${PERMISSIONS_BASE}/update-user-permissions`;
export const GET_MY_PERMISSIONS = `${API_BASE}${PERMISSIONS_BASE}/get-my-permissions`;

// Company
const COMPANY_BASE = "/company";
export const COMPANY_BASE_URL = `${API_BASE}${COMPANY_BASE}`;
export const GET_ALL_COMPANIES = `${API_BASE}${COMPANY_BASE}/get-all-companies`;
export const GET_COMPANY_ACCOUNT = `${API_BASE}${COMPANY_BASE}/account`;
export const UPDATE_COMPANY_ACCOUNT = `${API_BASE}${COMPANY_BASE}/account`;

// Tasks
const TASK_BASE = "/task";
export const CREATE_NEW_TASK = `${API_BASE}${TASK_BASE}/add-task`;
export const EDIT_TASK = `${API_BASE}${TASK_BASE}/update-submission-task`;
export const GET_SUBMISSION_TASKS = `${API_BASE}${TASK_BASE}/get-submission-tasks`;
export const GET_FORM_DEFAULT_TASKS = `${API_BASE}${TASK_BASE}/get-form-default-tasks`;
export const DELETE_SUBMISSION_TASKS = `${API_BASE}${TASK_BASE}/delete-task`;
export const UPDATE_TASKS_ORDER = `${API_BASE}${TASK_BASE}/update-task-order`;
export const COMPLETE_TASK_SUBMIT = `${API_BASE}${TASK_BASE}/submit-completed-task`;
export const GET_MY_TASKS = `${API_BASE}${TASK_BASE}/get-my-tasks`;
export const GET_ALL_MY_TASKS = `${API_BASE}${TASK_BASE}/get-all-my-tasks`;
export const REASSIGN_TASK = `${API_BASE}${TASK_BASE}/reassign-task`;

// Notifications
const NOTIFICATIONS_BASE = "/notifications";
export const GET_MY_NOTIFICATIONS = `${API_BASE}${NOTIFICATIONS_BASE}/mine`;
export const GET_ALL_MY_NOTIFICATIONS = `${API_BASE}${NOTIFICATIONS_BASE}/all`;
export const MARK_NOTIFICATION_READ = `${API_BASE}${NOTIFICATIONS_BASE}/mark-read`;

// Positions
const POSITION_BASE = "/position";
export const CREATE_NEW_POSITION = `${API_BASE}${POSITION_BASE}/add-position`;
export const GET_ALL_POSITIONS = `${API_BASE}${POSITION_BASE}/get-positions`;
export const GET_COMPANY_POSITIONS = `${API_BASE}${POSITION_BASE}/get-company-positions`;
export const UPDATE_POSITION = `${API_BASE}${POSITION_BASE}/update-position`;
export const SET_USER_POSITION_ASSIGNMENTS = `${API_BASE}${POSITION_BASE}/set-user-assignments`;
export const DELETE_POSITION = `${API_BASE}${POSITION_BASE}/delete-position`;
export const POSITION_USAGE = `${API_BASE}${POSITION_BASE}/position-usage`;

// Files
const FILE_BASE = "/file";
export const DOWNLOAD_FILE = `${API_BASE}${FILE_BASE}/download`;
export const DELETE_FILE = `${API_BASE}${FILE_BASE}/delete-file`;

// Payments
const PAYMENTS_BASE = "/stripe";
export const CREATE_SESSION = `${API_BASE}${PAYMENTS_BASE}/create-checkout-session`;
export const CREATE_PAYMENT_INTENT = `${API_BASE}${PAYMENTS_BASE}/create-payment-intent`;

//Analytics
const ANALYTICS_BASE = "/analytics";
export const SUBMITTED_REPORTS = `${API_BASE}${ANALYTICS_BASE}/get-submitted-reports-data`;
export const TASKS_DATA = `${API_BASE}${ANALYTICS_BASE}/get-tasks-data`;
export const GET_MY_FORMS_SHORT = `${API_BASE}${ANALYTICS_BASE}/get-my-forms`;
export const SEARCH_REPORT_ANALYTICS = `${API_BASE}${ANALYTICS_BASE}/search-reports`;
export const GENERATE_DUMMY_DATA = `${API_BASE}${ANALYTICS_BASE}/generate-dummy-data`;

//GLAccounts
const GL_ACCOUNT_BASE = "/glAccount";
export const CREATE_GL_ACCOUNT = `${API_BASE}${GL_ACCOUNT_BASE}`;
export const GET_COMPANY_GL_ACCOUNTS = `${API_BASE}${GL_ACCOUNT_BASE}/get-company-gl-accounts`;
export const ACTIVATE_DEACTIVATE_GL_ACCOUNTS = `${API_BASE}${GL_ACCOUNT_BASE}/activate-deactivate`;

// Groups
const GROUP_BASE = "/group";
export const CREATE_GROUP = `${API_BASE}${GROUP_BASE}`;
export const GET_GROUPS = `${API_BASE}${GROUP_BASE}/get-company-groups`;

// Assets
const ASSET_BASE = "/asset";
export const CREATE_ASSET = `${API_BASE}${ASSET_BASE}`;
export const GET_ASSET = `${API_BASE}${ASSET_BASE}/get-asset`;
export const CREATE_ASSET_FIELD = `${API_BASE}${ASSET_BASE}/add-asset-field`;
export const EDIT_ASSET_PROPERTY = `${API_BASE}${ASSET_BASE}/edit-asset-property`;
export const EDIT_ASSET_FIELD = `${API_BASE}${ASSET_BASE}/edit-asset-field`;
export const EDIT_FIELD_OPTIONS = `${API_BASE}${ASSET_BASE}/edit-field-options`;
export const ADD_ASSET_PHOTO = `${API_BASE}${ASSET_BASE}/add-asset-photo`;
export const ADD_ASSET_FIELD_FILE = `${API_BASE}${ASSET_BASE}/add-asset-field-attachment`;
export const DELETE_ASSET_FILE = `${API_BASE}${ASSET_BASE}/delete-asset-file-attachment`;
export const ADD_PM_ASSIGNMENT = `${API_BASE}${ASSET_BASE}/add-preventative-maintenance`;
export const EDIT_PM_ASSIGNMENT = `${API_BASE}${ASSET_BASE}/edit-preventative-maintenance`;
export const GET_PM_ASSIGNMENT = `${API_BASE}${ASSET_BASE}/get-company-preventative-maintenance-assignments`;
export const DELETE_PM_ASSIGNMENT = `${API_BASE}${ASSET_BASE}/delete-preventative-maintenance`;
export const GET_ASSET_FORMS = `${API_BASE}${ASSET_BASE}/get-asset-forms`;
export const GET_ASSET_REPORTS = `${API_BASE}${ASSET_BASE}/get-asset-reports`;
export const GET_ASSET_TASKS = `${API_BASE}${ASSET_BASE}/get-asset-tasks`;
export const GET_ASSET_CATEGORIES = `${API_BASE}${ASSET_BASE}/get-categories`;
export const CREATE_ASSET_CATEGORY = `${API_BASE}${ASSET_BASE}/create-category`;
export const DELETE_ASSET_CATEGORY = `${API_BASE}${ASSET_BASE}/delete-category`;
export const DELETE_ASSET_CATEGORY_FIELD = `${API_BASE}${ASSET_BASE}/delete-category-default-field`;
export const ADD_FIELD_TASK_RULE = `${API_BASE}${ASSET_BASE}/add-field-task-rule`;
export const EDIT_FIELD_TASK_RULE = `${API_BASE}${ASSET_BASE}/edit-field-task-rule`;
export const DELETE_FIELD_TASK_RULE = `${API_BASE}${ASSET_BASE}/delete-field-task-rule`;
export const DISPOSE_ASSET = `${API_BASE}${ASSET_BASE}/dispose-asset`;
export const GET_DISPOSED_ASSETS = `${API_BASE}${ASSET_BASE}/get-disposed-assets`;
export const GET_ASSET_VENDORS = `${API_BASE}${ASSET_BASE}/get-asset-vendors`;
export const DELETE_ASSET_VENDOR = `${API_BASE}${ASSET_BASE}/delete-assets-vendor`;

// Vendors
const VENDOR_BASE = "/vendors";
export const ADD_VENDOR = `${API_BASE}${VENDOR_BASE}`;
export const EDIT_VENDOR = `${API_BASE}${VENDOR_BASE}`;
export const DELETE_VENDOR = `${API_BASE}${VENDOR_BASE}`;
export const GET_VENDORS = `${API_BASE}${VENDOR_BASE}`;
export const GET_VENDOR = `${API_BASE}${VENDOR_BASE}/get-vendor-by-id`;
export const ADD_VENDOR_PHOTO = `${API_BASE}${VENDOR_BASE}/add-vendor-photo`;
export const ADD_VENDOR_FIELD = `${API_BASE}${VENDOR_BASE}/add-vendor-field`;
export const GET_VENDOR_FIELDS = `${API_BASE}${VENDOR_BASE}/get-vendor-fields`;
export const GET_VENDOR_FILES = `${API_BASE}${VENDOR_BASE}/get-vendor-files`;
export const ADD_VENDOR_DOCUMENT = `${API_BASE}${VENDOR_BASE}/document`;
export const DELETE_VENDOR_DOCUMENT = `${API_BASE}${VENDOR_BASE}/document`;
export const GET_VENDOR_CONTACTS = `${API_BASE}${VENDOR_BASE}/contacts`;
export const ADD_VENDOR_CONTACT = `${API_BASE}${VENDOR_BASE}/contact`;
export const EDIT_VENDOR_CONTACT = `${API_BASE}${VENDOR_BASE}/contact`;
export const DELETE_VENDOR_CONTACT = `${API_BASE}${VENDOR_BASE}/contact`;
export const GET_VENDOR_ASSETS = `${API_BASE}${VENDOR_BASE}/assets`;
export const ADD_VENDOR_ASSET = `${API_BASE}${VENDOR_BASE}/asset`;
export const DELETE_VENDOR_ASSET = `${API_BASE}${VENDOR_BASE}/asset`;
export const GET_VENDOR_LOCATIONS = `${API_BASE}${VENDOR_BASE}/locations`;
export const ADD_VENDOR_LOCATION = `${API_BASE}${VENDOR_BASE}/location`;
export const DELETE_VENDOR_LOCATION = `${API_BASE}${VENDOR_BASE}/location`;
export const SEARCH_VENDOR_CONTACTS = `${API_BASE}${VENDOR_BASE}/search-vendor-contacts`;
